import {
    Location,
    OpenAPI,
    LocationService
} from '../openapi';
import { ApiResult } from '../openapi/core/ApiResult';

const { get, get1, getTotalCount } = LocationService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getLocations = async (token: string, range: string, filter?: Record<string, string>, search?: Record<string, string>) => {
    const locations: ApiResult = await get(token, range, filter, search);
    return locations;
};

export const getLocationCount = async (token: string, filter?: Record<string, string>, search?: Record<string, string>): Promise<string> => {
    const result: string = await getTotalCount(token, filter, search);
    const count = result.split('/')[1];
    return count;
};

export const getLocationById = async (token: string, id: string): Promise<Location> => {
    return await get1(token, id);
};

